import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { FormControl, FormGroup, Form, Button } from "react-bootstrap";

import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import trash from "../../images/trash.svg";
import NoIndex from "../NoIndex";
import Chat_BG from "../../images/chat_BG.png";
import Loader from "./Loader";
import MyContext from "../../MyContext"; //using ContextAPI to store data dynamically
import { setLanguage } from "react-geocode";

const emojiCategories = {
  "😀": [
    "😀",
    "😁",
    "😂",
    "🤣",
    "😃",
    "😄",
    "😅",
    "😆",
    "😉",
    "😊",
    "😋",
    "😎",
    "😍",
    "😘",
    "😗",
    "😙",
    "😚",
    "🙂",
    "🤗",
    "🤩",
    "🥳",
    "😏",
    "😒",
    "😞",
    "😔",
    "😟",
    "😢",
    "😭",
    "😤",
    "😠",
    "😡",
    "🤬",
    "🤯",
    "😳",
    "🥺",
    "😨",
    "😰",
    "😥",
    "🤥",
    "🤫",
    "🤭",
    "🫢",
    "🫡",
    "🤔",
    "🙄",
    "😬",
    "😴",
    "🥱",
    "🤤",
    "🤢",
  ],

  "🖐️": [
    "👋",
    "🤚",
    "🖐️",
    "✋",
    "🖖",
    "👌",
    "🤌",
    "🤏",
    "✌️",
    "🤞",
    "🤟",
    "🤘",
    "🤙",
    "👈",
    "👉",
    "👆",
    "🖕",
    "👇",
    "☝️",
    "👍",
    "👎",
    "✊",
    "👊",
    "🤛",
    "🤜",
    "👏",
    "🙌",
    "👐",
    "🤲",
    "🙏",
  ],

  "🍕": [
    "🍏",
    "🍎",
    "🍐",
    "🍊",
    "🍋",
    "🍌",
    "🍉",
    "🍇",
    "🍓",
    "🫐",
    "🥭",
    "🍍",
    "🥥",
    "🥑",
    "🥦",
    "🥒",
    "🌽",
    "🍠",
    "🥔",
    "🥕",
    "🌰",
    "🥜",
    "🍞",
    "🥐",
    "🥖",
    "🫓",
    "🥞",
    "🧇",
    "🍗",
    "🍖",
    "🍕",
    "🌭",
    "🍔",
    "🍟",
    "🍜",
    "🍣",
    "🍩",
    "🍪",
    "🎂",
    "🍫",
  ],

  "🎉": [
    "🎃",
    "🎄",
    "🎆",
    "🎇",
    "🎈",
    "🎉",
    "🎊",
    "🎁",
    "🎀",
    "🎤",
    "🎧",
    "🎼",
    "🎷",
    "🎸",
    "🎻",
    "🥁",
    "🎮",
    "🕹️",
    "🎰",
    "🎳",
    "⛳",
    "🥊",
    "🏀",
    "⚽",
    "🏈",
    "⚾",
    "🥎",
    "🎾",
    "🎱",
    "🏆",
  ],

  "🚗": [
    "🚗",
    "🚕",
    "🚙",
    "🚌",
    "🚎",
    "🏎️",
    "🚓",
    "🚑",
    "🚒",
    "🚜",
    "✈️",
    "🚀",
    "🛸",
    "⛵",
    "🛳️",
    "🗺️",
    "🏝️",
    "🏞️",
    "🏰",
    "🗽",
  ],

  "💡": [
    "❤️",
    "💙",
    "💚",
    "💛",
    "💜",
    "🖤",
    "🤍",
    "🤎",
    "💔",
    "❣️",
    "💥",
    "💢",
    "💦",
    "💨",
    "🔥",
    "⭐",
    "🌟",
    "✨",
    "⚡",
    "💫",
    "💬",
    "🗨️",
    "🗯️",
    "💭",
    "🕒",
    "⏳",
    "🕰️",
    "🛑",
    "🚸",
    "⚠️",
  ],

  "📞": [
    "📞",
    "☎️",
    "📱",
    "📲",
    "🖥️",
    "💻",
    "⌨️",
    "🖱️",
    "🖲️",
    "📟",
    "📠",
    "📺",
    "📻",
    "🎙️",
    "📡",
    "📩",
    "✉️",
    "📧",
    "📨",
    "📬",
  ],

  "💼": [
    "💼",
    "📊",
    "📈",
    "📉",
    "📅",
    "📆",
    "📝",
    "🖊️",
    "🖋️",
    "✒️",
    "📎",
    "📏",
    "📐",
    "📂",
    "📌",
    "🔖",
    "🗄️",
    "🏢",
    "🏦",
    "🏛️",
  ],
};

const countryCodes = [
  { code: "91", label: "🇮🇳 India (+91)" },
  { code: "1", label: "🇺🇸 USA (+1)" },
  { code: "44", label: "🇬🇧 UK (+44)" },
  { code: "61", label: "🇦🇺 Australia (+61)" },
  { code: "81", label: "🇯🇵 Japan (+81)" },
  { code: "971", label: "🇦🇪 UAE (+971)" },
  { code: "49", label: "🇩🇪 Germany (+49)" },
  { code: "33", label: "🇫🇷 France (+33)" },
  { code: "39", label: "🇮🇹 Italy (+39)" },
  { code: "34", label: "🇪🇸 Spain (+34)" },
  { code: "7", label: "🇷🇺 Russia (+7)" },
  { code: "86", label: "🇨🇳 China (+86)" },
  { code: "55", label: "🇧🇷 Brazil (+55)" },
  { code: "27", label: "🇿🇦 South Africa (+27)" },
  { code: "62", label: "🇮🇩 Indonesia (+62)" },
  { code: "82", label: "🇰🇷 South Korea (+82)" },
  { code: "90", label: "🇹🇷 Turkey (+90)" },
  { code: "52", label: "🇲🇽 Mexico (+52)" },
  { code: "880", label: "🇧🇩 Bangladesh (+880)" },
  { code: "92", label: "🇵🇰 Pakistan (+92)" },
  { code: "66", label: "🇹🇭 Thailand (+66)" },
  { code: "20", label: "🇪🇬 Egypt (+20)" },
  { code: "98", label: "🇮🇷 Iran (+98)" },
  { code: "31", label: "🇳🇱 Netherlands (+31)" },
  { code: "46", label: "🇸🇪 Sweden (+46)" },
  { code: "47", label: "🇳🇴 Norway (+47)" },
  { code: "48", label: "🇵🇱 Poland (+48)" },
  { code: "32", label: "🇧🇪 Belgium (+32)" },
  { code: "30", label: "🇬🇷 Greece (+30)" },
  { code: "43", label: "🇦🇹 Austria (+43)" },
  { code: "351", label: "🇵🇹 Portugal (+351)" },
  { code: "64", label: "🇳🇿 New Zealand (+64)" },
  { code: "63", label: "🇵🇭 Philippines (+63)" },
  { code: "41", label: "🇨🇭 Switzerland (+41)" },
  { code: "45", label: "🇩🇰 Denmark (+45)" },
  { code: "351", label: "🇵🇹 Portugal (+351)" },
  { code: "56", label: "🇨🇱 Chile (+56)" },
  { code: "93", label: "🇦🇫 Afghanistan (+93)" },
  { code: "94", label: "🇱🇰 Sri Lanka (+94)" },
  { code: "233", label: "🇬🇭 Ghana (+233)" },
  { code: "234", label: "🇳🇬 Nigeria (+234)" },
  { code: "36", label: "🇭🇺 Hungary (+36)" },
  { code: "212", label: "🇲🇦 Morocco (+212)" },
  { code: "213", label: "🇩🇿 Algeria (+213)" },
  { code: "216", label: "🇹🇳 Tunisia (+216)" },
  { code: "250", label: "🇷🇼 Rwanda (+250)" },
  { code: "254", label: "🇰🇪 Kenya (+254)" },
  { code: "256", label: "🇺🇬 Uganda (+256)" },
  { code: "62", label: "🇮🇩 Indonesia (+62)" },
];

const CreateTemplate = ({ userID }) => {
  const emojiPickerRef = useRef(null);
  const { baseUrl, config } = useContext(MyContext);
  const buttonTypeSelectRef = useRef(null);
  const [includeHeader, setIncludeHeader] = useState(false);
  const [includeHeader_withoutVariable, setIncludeHeader_withoutVariable] =
    useState(false);
  const [includeFooter, setIncludeFooter] = useState(false);
  const [includeButtons, setIncludeButtons] = useState(false);
  const [template1, setTemplate1] = useState({ body: "" });
  const [variables, setVariables] = useState([]);
  const [template1header, setTemplate1header] = useState({ body: "" });
  const [variablesheader, setVariablesheader] = useState([]);
  const [imageFile, setImageFile] = useState([]);
  const [imageLink, setImageLink] = useState("");
  const [base64String, setBase64String] = useState("");
  const [imageName, setImageName] = useState("");
  const [videoLink, setVideoLink] = useState("");
  const [videoFile, setVideoFile] = useState("");
  const [documentLink, setDocumentLink] = useState("");
  const [documentFile, setDocumentFile] = useState("");
  const [Languages, setLanguages] = useState([]);
  const [mediaUploadLoading, setMediaUploadLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [WhatsappNumbers, setWhatsappNumbers] = useState([]);
  const [MultiplePhoneNumber, setMultiplePhoneNumber] = useState(false);
  const [SingleWhatsApp, setSingleWhatsApp] = useState("");
  const [selectedCode, setSelectedCode] = useState("91");
  const [VideoLoader, setVideoLoader] = useState(false)
  let BASIC_AUTH = "YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=";

  const [template, setTemplate] = useState({
    name: "",
    type: "",
    language: "",
    category: "",
    purpose: "",
    header: "",
    body: "",
    footer: "",
    headerType: "",
    buttonType: "",
    button: "",

    showButton4_quick1: "",
    showButton4_quick2: "",
    showButton4_quick3: "",
    showButton4_quick4: "",

    showButton4Value_quick1: "",
    showButton4Value_quick2: "",
    showButton4Value_quick3: "",
    showButton4Value_quick4: "",

    showButton4option_quick1: "",
    showButton4option_quick2: "",
    showButton4option_quick3: "",
    showButton4option_quick4: "",
    showButton4_quick3_url: "",
    showButton4_quick3_call: "",
    selectButton: "",
  });
  const [response, setResponse] = useState(null);
  const [components, setComponents] = useState([]);
  const [isAddVariableClicked, setIsAddVariableClicked] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(
    Object.keys(emojiCategories)[0]
  );

  const insertEmoji = (emoji) => {
    const textarea = document.getElementById("bodyTextarea");
    if (!textarea) return;

    const { selectionStart, selectionEnd } = textarea;
    const newText =
      template1.body.slice(0, selectionStart) +
      emoji +
      template1.body.slice(selectionEnd);

    handleInputChange1({ target: { name: "body", value: newText } }); // Update state properly

    setShowEmojiPicker(false); // Hide picker after selection
  };

  const getLanguages = async (e) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Basic ${BASIC_AUTH}`);
      var raw = JSON.stringify({
        userid: userID,
        secret: "N",
      });
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${baseUrl}/api/Whatsapp/v1.0/getLanguages`,
        requestOptions
      );
      const data = await res.json();
      if (data?.responseCode == "00") {
        setLanguages(data?.data);
      } else {
      }
    } catch (error) { }
  };
  useEffect(() => {
    getLanguages();
  }, []);

  const clearForm = () => {
    // Reset all individual states
    setIncludeHeader(false);
    setIncludeHeader_withoutVariable(false);
    setIncludeFooter(false);
    setIncludeButtons(false);
    setTemplate1({ body: "" });
    setVariables([]);
    setTemplate1header({ body: "" });
    setVariablesheader([]);
    setImageFile([]);
    setImageLink("");
    setBase64String("");
    setImageName("");
    setLoading(false);

    // Reset complex template state
    setTemplate({
      name: "",
      type: "",
      language: "",
      category: "",
      purpose: "",
      header: "",
      body: "",
      footer: "",
      headerType: "",
      buttonType: "",
      button: "",
      showButton4_quick1: "",
      showButton4_quick2: "",
      showButton4_quick3: "",
      showButton4_quick3_url: "",
      showButton4_quick3_call: "",
      showButton4Value_quick1: "",
      showButton4Value_quick2: "",
      showButton4Value_quick3: "",
      showButton4Value_quick4: "",
      showButton4option_quick1: "",
      showButton4option_quick2: "",
      showButton4option_quick3: "",
      showButton4option_quick4: "",

      selectButton: "",
    });

    // Reset any response or components
    setResponse(null);
    setComponents([]);
    setIsAddVariableClicked(false);

    // Reset the ref, if applicable
    if (buttonTypeSelectRef.current) {
      buttonTypeSelectRef.current.value = ""; // Clear the select reference
    }

    // Add any additional cleanup as required
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const originalName = file.name;
      const nameWithoutExt =
        originalName.substring(0, originalName.lastIndexOf(".")) ||
        originalName;
      console.log("Original Filename:", originalName);
      console.log("Filename without Extension:", nameWithoutExt);

      setImageFile([file]);
      setImageName(nameWithoutExt);

      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64String(reader.result);
        convertImage(nameWithoutExt, reader.result); // Pass the name and base64 string to the function
      };
      reader.readAsDataURL(file);
    }
  };
  const convertImage = async (imageName, base64String) => {
    try {
      const requestBody = {
        userid: userID,
        item_name: imageName,
        type: "IMG",
        image_data: base64String,
      };
      const response = await axios.post(
        "https://bumppy.in/Dhroom/api/v1/uploadItemImage.php",
        requestBody,
        config
      );
      console.log(response.data.image_url);
      if (response.data.status === "0") {
        setImageLink(response.data.image_url);
        console.log(imageLink);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleVideoUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      if (file.type === "video/mp4") {
        if (file.size > 16 * 1024 * 1024) {
          alert("Video file size must be 16MB or less.");
          // removeFile();
          return;
        }

        setVideoFile(file);
        // Handle Video Selection
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64Data = reader.result.split(",")[1]; // Extract Base64 part
          // setSelectedFileUpload(base64Data);
          uploadVideoAPI(base64Data);
          // convertVideo(base64Data);
        };
        reader.onerror = (error) =>
          console.error("Error reading video file:", error);
      } else {
        alert(`Please select a valid  file.`);
      }
    }
  };

  const uploadVideoAPI = async (fileData) => {
    if (!fileData) return;
    setMediaUploadLoading(true);
    const payload = {
      userid: userID, // Replace with actual user ID
      mediaData: fileData, // Base64 of the file
      mediaType: "video",
    };

    try {
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/uploadMedia`,
        payload,
        {
          headers: config.headers,
        }
      );
      if (response.data.responseCode === "00") {
        toast.success("Video uploaded successfully");
        setVideoLink(response.data.data.mediaUrl);
        // random
        // removeFile();
      } else {
        console.error("Failed to upload file", response);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setMediaUploadLoading(false);
    }
  };

  const handleDocumentUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      ];
      if (!allowedTypes.includes(file.type)) {
        alert(
          "Please select a valid document file (PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX)."
        );
        return;
      }
      if (file.size > 16 * 1024 * 1024) {
        alert("Document file size must be 16MB or less.");
        return;
      }
      setDocumentFile(file); // Save file in state
      // Convert file to Base64
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64Data = reader.result.split(",")[1]; // Extract Base64 part
        uploadDocumentAPI(base64Data, file.type);
      };
      reader.onerror = (error) =>
        console.error("Error reading document file:", error);
    }
  };
  const uploadDocumentAPI = async (fileData, fileType) => {
    if (!fileData) return;
    setMediaUploadLoading(true);
    const payload = {
      userid: userID, // Replace with actual user ID
      mediaData: fileData, // Base64 of the file
      mediaType: "pdf",
      fileType: "application/pdf",
    };
    try {
      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/uploadMedia`,
        payload,
        {
          headers: config.headers,
        }
      );

      if (response.data.responseCode === "00") {
        toast.success("Document uploaded successfully");
        setDocumentLink(response.data.data.mediaUrl);
      } else {
        console.error("Failed to upload document", response);
      }
    } catch (error) {
      console.error("Error uploading document:", error);
    } finally {
      setMediaUploadLoading(false);
    }
  };

  useEffect(() => {
    const bodyText = variables.map((variable) => variable.value);
    const formattedBodyText = [bodyText];
    console.log(variables.length);
    let newComponents = [];

    if (variables.length === 0) {
      newComponents = [
        {
          type: "BODY",
          text: template1.body,
          // example: {
          //   body_text: formattedBodyText,
          // },
        },
      ];
    } else if (variables.length !== 0) {
      newComponents = [
        {
          type: "BODY",
          text: template1.body,
          example: {
            body_text: formattedBodyText,
          },
        },
      ];
    }

    if (includeHeader && template.headerType === "Text") {
      const headerText = variablesheader.map((variable) => variable.value);
      newComponents.push({
        type: "HEADER",
        format: "TEXT",
        text: template1header.body,
        // example: {
        //   header_text: headerText,
        // },
      });
    }

    if (includeHeader_withoutVariable) {
      newComponents.push({
        type: "HEADER",
        format: "TEXT",
        text: template1header.body,
      });
    }

    if (includeFooter) {
      newComponents.push({
        type: "FOOTER",
        text: template.footer,
      });
    }

    if (includeButtons && template.purpose !== "1") {
      const buttons = [];
      if (template.showButton4_quick1) {
        buttons.push({
          type: "QUICK_REPLY",
          text: template.showButton4_quick1,
        });
      }
      if (template.showButton4_quick2) {
        buttons.push({
          type: "QUICK_REPLY",
          text: template.showButton4_quick2,
        });
      }

      if (template.showButton4_quick3 && template.showButton4_quick3_url) {
        buttons.push({
          type: "URL",
          text: template.showButton4_quick3,
          url: template.showButton4_quick3_url,
        });
      }
      if (template.showButton4_quick4 && template.showButton4_quick3_call) {
        buttons.push({
          type: "PHONE_NUMBER",
          text: template.showButton4_quick4,
          phone_number: template.showButton4_quick3_call,
        });
      }
      newComponents.push({
        type: "BUTTONS",
        buttons: buttons,
      });
    }

    if (template.purpose === "1") {
      const buttons = [];
      setIncludeButtons(true);

      setTemplate({
        ...template,
        // showButton4_quick1: "Intrested",
        // showButton4_quick2:"Not Intrested",
        showButton4option_quick1: "4",
        showButton4option_quick2: "5",
        // showButton4Value_quick1:"Intrested",
        // showButton4Value_quick2:"Not Intrested",
      });
      buttons.push({
        type: "QUICK_REPLY",
        text: template.showButton4_quick1,
      });
      buttons.push({
        type: "QUICK_REPLY",
        text: template.showButton4_quick2,
      });

      if (template.showButton4_quick3 && template.showButton4_quick3_url) {
        buttons.push({
          type: "URL",
          text: template.showButton4_quick3,
          url: template.showButton4_quick3_url,
        });
      }
      newComponents.push({
        type: "BUTTONS",
        buttons: buttons,
      });
    }

    setComponents(newComponents);
  }, [
    includeHeader,
    includeFooter,
    includeButtons,
    template1.body,
    variables,
    template1header.body,
    variablesheader,
    template.footer,
    template.showButton4_quick1,
    template.showButton4_quick2,
    template.showButton4_quick3,
    template.showButton4_quick3_url,
    template.showButton4_quick3_call,
    template.headerType,
    template.purpose,
  ]);

  const validateTemplate = () => {
    if (!template.name) {
      return "Template Name is required.";
    }
    if (!template.language) {
      return "Template Language is required.";
    }
    if (!template.category) {
      return "Template Category is required.";
    }
    // if (!template.purpose) {
    //   return "Template Purpose is required.";
    // }
    const bodyText = template1.body.trim();
    const words = bodyText.split(/\s+/);
    const variableWords = words.filter((word) => word.match(/^\{\{.*\}\}$/));
    if (variableWords.length > 0) {
      const nonVariableWords = words.filter(
        (word) => !word.match(/^\{\{.*\}\}$/)
      ).length;

      if (nonVariableWords < 3) {
        return "Body must contain at least three words when variables are added.";
      }
    } else {
      if (bodyText === "") {
        return "Body cannot be empty.";
      }
    }
    if (template.showButton4option_quick1 && !template.showButton4_quick1) {
      return "Button-1 name is required.";
    }
    if (template.showButton4option_quick2 && !template.showButton4_quick2) {
      return "Button-2 name is required.";
    }
    if (template.showButton4option_quick3 && !template.showButton4_quick3) {
      return "Button-3 name is required.";
    }
    if (template.showButton4option_quick4 && !template.showButton4_quick4) {
      return "Button-4 name is required.";
    }
    if (
      template.showButton4option_quick3 &&
      template.showButton4_quick3 &&
      !template.showButton4_quick3_url
    ) {
      return "Enter Website URL";
    }
    if (
      template.showButton4option_quick4 &&
      template.showButton4_quick4 &&
      !template.showButton4_quick3_call
    ) {
      return "Enter Phone Number";
    }
    return null;
  };

  const chooseAPI = async () => {
    if (template.headerType === "Image") {
      createTemplateApi_Image();
    } else if (template.headerType === "Video") {
      createTemplateApi_Video();
    } else if (template.headerType === "Document") {
      createTemplateApi_Document();
    } else {
      createTemplateApi();
    }
  };

  const createTemplateApi = async () => {
    if (includeHeader && !template1header.body) {
      toast.error("Please fill in the Header field.");
      return;
    }
    if (includeFooter && !template.footer) {
      toast.error("Please fill in the Footer field.");
      return;
    }
    if (
      includeButtons &&
      !template.showButton4option_quick1 &&
      !template.showButton4option_quick2 &&
      !template.showButton4option_quick3 &&
      !template.showButton4option_quick4
    ) {
      toast.error("Please fill in the Button field.");
      return;
    }
    const validationError = validateTemplate();
    if (validationError) {
      toast.error(validationError);
      return;
    }
    try {
      setLoading(true);

      const data = {
        userid: userID,
        secret: "string",
        name: template.name,
        language: template.language,
        category: template.category,
        phoneNumberId: SingleWhatsApp,
        purpose: template.purpose,
        components: components,
      };

      const response = await fetch(
        `${baseUrl}/api/Whatsapp/v1.0/createTemplate`,
        {
          method: "POST",
          headers: config.headers,
          body: JSON.stringify(data),
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const responseData = await response.json();
      setResponse(responseData);
      if (responseData.responseCode === "00") {
        toast.success(responseData.responseMessage);
        clearForm();
      } else {
        toast.error(responseData.responseMessage);
      }
    } catch (error) {
      console.error("Error:", error.message);
      toast.error("Failed to create template. Please try again later.");
    } finally {
      setLoading(false); // Set loading to false after API call
    }
  };

  const createTemplateApi_Image = async () => {
    if (!imageLink) {
      toast.error("Please upload image in the header.");
      return;
    }

    if (includeFooter && !template.footer) {
      toast.error("Please fill in the Footer field.");
      return;
    }
    if (
      includeButtons &&
      !template.showButton4option_quick1 &&
      !template.showButton4option_quick2 &&
      !template.showButton4option_quick3 &&
      !template.showButton4option_quick4
    ) {
      toast.error("Please fill in the Button field.");
      return;
    }
    const validationError = validateTemplate();
    if (validationError) {
      toast.error(validationError);
      return;
    }
    try {
      setLoading(true);

      const data = {
        userid: userID,
        secret: "fjrdtunfgngf",
        name: template.name,
        language: template.language,
        category: template.category,
        //  image: imageLink,
        image:
          "https://bumppy.in/Dhroom/api/v1/uploads/catalog_items/_A1020_Screenshot2.png",
        phoneNumberId: SingleWhatsApp,
        components: components,
      };
      const response = await fetch(
        `${baseUrl}/api/Whatsapp/v1.0/createImageTemplate`,
        {
          method: "POST",
          headers: config.headers,
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();
      setResponse(responseData);
      if (responseData.responseCode === "00") {
        toast.success(responseData.responseMessage);
        clearForm();
      } else {
        toast.error(responseData.responseMessage);
      }
    } catch (error) {
      console.error("Error:", error.message);
      toast.error("Failed to create template. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const createTemplateApi_Video = async () => {
    if (!videoLink) {
      toast.error("Please upload video in the header.");
      return;
    }

    if (includeFooter && !template.footer) {
      toast.error("Please fill in the Footer field.");
      return;
    }
    if (
      includeButtons &&
      !template.showButton4option_quick1 &&
      !template.showButton4option_quick2 &&
      !template.showButton4option_quick3 &&
      !template.showButton4option_quick4
    ) {
      toast.error("Please fill in the Button field.");
      return;
    }
    const validationError = validateTemplate();
    if (validationError) {
      toast.error(validationError);
      return;
    }
    try {
      setLoading(true);

      const data = {
        userid: userID,
        secret: "fjrdtunfgngf",
        name: template.name,
        language: template.language,
        category: template.category,
        // video:"https://bumppy.in/Dhroom/api/v1/uploads/media_files/20250327154652868229.mp4",
        video: videoLink,
        phoneNumberId: SingleWhatsApp,
        components: components,
      };
      const response = await fetch(
        `${baseUrl}/api/Whatsapp/v1.0/createVideoTemplate`,
        {
          method: "POST",
          headers: config.headers,
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();
      setResponse(responseData);
      if (responseData.responseCode === "00") {
        toast.success(responseData.responseMessage);
        clearForm();
      } else {
        toast.error(responseData.responseMessage);
      }
    } catch (error) {
      console.error("Error:", error.message);
      toast.error("Failed to create template. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const createTemplateApi_Document = async () => {
    if (!documentLink) {
      toast.error("Please upload document in the header.");
      return;
    }

    if (includeFooter && !template.footer) {
      toast.error("Please fill in the Footer field.");
      return;
    }
    if (
      includeButtons &&
      !template.showButton4option_quick1 &&
      !template.showButton4option_quick2 &&
      !template.showButton4option_quick3 &&
      !template.showButton4option_quick4
    ) {
      toast.error("Please fill in the Button field.");
      return;
    }
    const validationError = validateTemplate();
    if (validationError) {
      toast.error(validationError);
      return;
    }

    try {
      setLoading(true);

      const data = {
        userid: userID,
        secret: "fjrdtunfgngf",
        name: template.name,
        language: template.language,
        category: template.category,

        document:
          "https://bumppy.in/Dhroom/api/v1/uploads/media_files/20250328115452455405.pdf",
        phoneNumberId: SingleWhatsApp,
        components: components,
      };

      const response = await fetch(
        `${baseUrl}/api/Whatsapp/v1.0/createDocumentTemplate`,
        {
          method: "POST",
          headers: config.headers,
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();
      setResponse(responseData);
      if (responseData.responseCode === "00") {
        toast.success(responseData.responseMessage);
        clearForm();
      } else {
        toast.error(responseData.responseMessage);
      }
    } catch (error) {
      console.error("Error:", error.message);
      toast.error("Failed to create template. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveButton4_quick1 = (e) => {
    setTemplate((prevState) => ({
      ...prevState,
      showButton4_quick1: "",
      showButton4Value_quick1: "",
      showButton4option_quick1: "",
      selectButton: ",",
    }));
    if (buttonTypeSelectRef.current) {
      buttonTypeSelectRef.current.value = "";
    }
  };
  const handleRemoveButton4_quick2 = (e) => {
    setTemplate((prevState) => ({
      ...prevState,
      showButton4_quick2: "",
      showButton4Value_quick2: "",
      showButton4option_quick2: "",
      selectButton: ",",
    }));
    if (buttonTypeSelectRef.current) {
      buttonTypeSelectRef.current.value = "";
    }
  };
  const handleRemoveButton4_quick3 = (e) => {
    setTemplate((prevState) => ({
      ...prevState,
      showButton4_quick3: "",
      showButton4Value_quick3: "",
      showButton4option_quick3: "",
      selectButton: ",",
    }));
    if (buttonTypeSelectRef.current) {
      buttonTypeSelectRef.current.value = "";
    }
  };
  const handleRemoveButton4_quick4 = (e) => {
    setTemplate((prevState) => ({
      ...prevState,
      showButton4_quick4: "",
      showButton4Value_quick4: "",
      showButton4option_quick4: "",
      selectButton: ",",
    }));
    if (buttonTypeSelectRef.current) {
      buttonTypeSelectRef.current.value = "";
    }
  };



  const handleCreateTemplate = () => {
    createTemplateApi();
  };



  const handleCategoryChange = (event) => {
    const templateCategory = event.target.value;
    setTemplate((prevState) => ({
      ...prevState,
      category: templateCategory,
    }));
  };

  const handleLanguageChange = (event) => {
    const templateLanguage = event.target.value;
    setTemplate((prevState) => ({
      ...prevState,
      language: templateLanguage,
    }));
  };

  const handlePurposeChange = (event) => {
    const templatePurpose = event.target.value;
    setTemplate((prevState) => ({
      ...prevState,
      purpose: templatePurpose,
    }));
  };

  const handleInputChange1 = (e) => {
    const { name, value } = e.target;

    // Replace more than 10 consecutive spaces with exactly 10 spaces
    // Replace more than two consecutive new lines with exactly two new lines
    const sanitizedValue = value
      .replace(/ {11,}/g, '          ') // Replace 11 or more spaces with exactly 10 spaces
      .replace(/\n{3,}/g, '\n\n');     // Replace 3 or more consecutive new lines with exactly 2 new lines

    setTemplate1({ ...template1, [name]: sanitizedValue });
  };

  const applyFormatting = (formatType) => {
    const textarea = document.getElementById("bodyTextarea");
    const { selectionStart, selectionEnd } = textarea;
    const text = template1.body;

    if (selectionStart !== selectionEnd) {
      // Get the selected text
      let selectedText = text.substring(selectionStart, selectionEnd).trim(); // Ensure no extra spaces

      // Detect existing formatting
      const isBold = /^\*(.+?)\*$/.test(selectedText);
      const isItalic = /^_(.+?)_$/.test(selectedText);
      const isBoldItalic =
        /^_\*(.+?)\*_$/.test(selectedText) ||
        /^\*_(.+?)_\*$/.test(selectedText);

      let formattedText = selectedText; // Initialize with the original text

      if (formatType === "bold") {
        if (isBoldItalic) {
          formattedText = `_${selectedText.slice(2, -2)}_ `; // Remove bold, keep italic
        } else if (isBold) {
          formattedText = `${selectedText.slice(1, -1)} `; // Remove bold
        } else if (isItalic) {
          formattedText = `_*${selectedText.slice(1, -1)}*_ `; // Convert italic to bold-italic
        } else {
          formattedText = `*${formattedText}* `; // Apply bold
        }
      } else if (formatType === "italic") {
        if (isBoldItalic) {
          formattedText = `*${selectedText.slice(2, -2)}* `; // Remove italic, keep bold
        } else if (isItalic) {
          formattedText = `${selectedText.slice(1, -1)} `; // Remove italic
        } else if (isBold) {
          formattedText = `_*${selectedText.slice(1, -1)}*_ `; // Convert bold to bold-italic
        } else {
          formattedText = `_${formattedText}_ `; // Apply italic
        }
      } else if (formatType === "boldItalic") {
        if (isBoldItalic) {
          formattedText = `${selectedText.slice(2, -2)} `; // Remove bold-italic
        } else {
          formattedText = `_*${formattedText}*_ `; // Apply bold-italic
        }
      }

      // Update the body text with formatted selection
      const newText =
        text.substring(0, selectionStart) +
        formattedText +
        text.substring(selectionEnd);

      setTemplate1({ ...template1, body: newText });

      // Restore focus and selection after update
      setTimeout(() => {
        textarea.focus();
        textarea.setSelectionRange(
          selectionStart,
          selectionStart + formattedText.length
        );
      }, 0);
    }
  };

  // const handleInputChange1 = (e) => {
  //   const { name, value } = e.target;
  //   setTemplate1({ ...template, [name]: value });
  //   if (name === "type" && value !== "Text") {
  //     setTemplate1((prevTemplate) => ({ ...prevTemplate, header: "" }));
  //   }
  //   const updatedVariables = variables.filter((variable) => {
  //     return value.includes(variable.label);
  //   });
  //   setVariables(updatedVariables);
  // };

  const handleInputChange1header = (e) => {
    const { name, value } = e.target;
    // setTemplate1header({ ...template, [name]: value });
    setTemplate1header({ ...template1header, [e.target.name]: e.target.value });
    // Add condition to handle headerType changes
    if (name === "type" && value !== "Text") {
      // If headerType is not "Text", clear the header value
      setTemplate1header((prevTemplate) => ({ ...prevTemplate, header: "" }));
    }
    const updatedVariables = variablesheader.filter((variable) => {
      return value.includes(variable.label); // Check if the variable label exists in the new body text
    });
    setVariablesheader(updatedVariables);
  };

  const clearVideoImage = () => {
    setVideoFile("");
    setVideoLink("");
    setImageFile("");
    setImageLink("");
  };

  const handleHeaderTypeChange = (e) => {
    const { value } = e.target;

    clearVideoImage();
    setTemplate((prevTemplate) => ({
      ...prevTemplate,
      headerType: value,
      // Clear header value if headerType is not "Text"
      header: value !== "Text" ? "" : prevTemplate.header,
    }));
  };

  const handleButtonTypeChange = (e) => {
    const { value } = e.target;
    if (value === "4") {
      setTemplate((prevTemplate) => ({
        ...prevTemplate,
        buttonType: value,
        showButton4option_quick1: value,
      }));
    }

    if (value === "5") {
      setTemplate((prevTemplate) => ({
        ...prevTemplate,
        buttonType: value,
        showButton4option_quick2: value,
      }));
    }
    if (value === "6") {
      setTemplate((prevTemplate) => ({
        ...prevTemplate,
        buttonType: value,
        showButton4option_quick3: value,
      }));
    }
    if (value === "7") {
      setTemplate((prevTemplate) => ({
        ...prevTemplate,
        buttonType: value,
        showButton4option_quick4: value,
      }));
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Transform the input to lowercase
    setTemplate((prevState) => ({
      ...prevState,
      [name]: name === "footer" ? value : value.toLowerCase(),
    }));
  };
  const addVariableheader = () => {
    if (!isAddVariableClicked) {
      const nextVarNum = variablesheader.length + 1;

      // Ensure consistent formatting by adding curly braces around the variable
      const variableToAdd = ` {{${nextVarNum}}} `;
      setTemplate1header((prevTemplate) => ({
        ...prevTemplate,
        body: (prevTemplate.body || "") + variableToAdd,
      }));
      // Add the variable to the variables array
      setVariablesheader((prevVariables) => [
        ...prevVariables,
        { label: variableToAdd, value: "" },
      ]);
      setIsAddVariableClicked(true);
    }
  };
  const addVariable = () => {
    // Calculate the next variable number
    const nextVarNum = variables.length + 1;

    // Ensure consistent formatting by adding curly braces around the variable
    const variableToAdd = ` {{${nextVarNum}}} `;

    // Insert the variable into the body text
    setTemplate1((prevTemplate) => ({
      ...prevTemplate,
      body: (prevTemplate.body || "") + variableToAdd,
    }));

    // Add the variable to the variables array
    setVariables((prevVariables) => [
      ...prevVariables,
      { label: variableToAdd, value: "" },
    ]);
  };

  const handleVariableValueChangeheader = (index, value) => {
    setVariablesheader((prevVariables) => {
      const updatedVariables = [...prevVariables];
      updatedVariables[index].value = value;
      return updatedVariables;
    });
  };

  const replaceVariablesheader = (body) => {
    return body.replace(/\{\{(\d+)\}\}/g, (match, number) => {
      const variableIndex = parseInt(number) - 1;
      const variable = variablesheader[variableIndex];
      return variable ? variable.value : ""; // Return variable value if present, otherwise return nothing
    });
  };

  const handleVariableValueChange = (index, value) => {
    setVariables((prevVariables) => {
      const updatedVariables = [...prevVariables];
      updatedVariables[index].value = value;
      return updatedVariables;
    });
  };

  const formatWhatsAppText = (text) => {
    if (!text) return "";

    // 1) Basic escape so user text doesn't break HTML
    const escaped = text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

    return escaped
      // 2) Bold + italic (both variants):
      //    _*text*_  OR  *_text_*
      .replace(/_\*(.*?)\*_/g, "<b><i>$1</i></b>")
      .replace(/\*_(.*?)_\*/g, "<b><i>$1</i></b>")

      // 3) Bold: *text*
      .replace(/\*(.*?)\*/g, "<b>$1</b>")

      // 4) Italic: _text_
      .replace(/_(.*?)_/g, "<i>$1</i>")

      // 5) New lines → <br/>
      .replace(/\n/g, "<br/>");
  };


  const replaceVariables = (body) => {
    if (!body) return "";

    let replacedText = body.replace(/\{\{(\d+)\}\}/g, (match, number) => {
      const variableIndex = parseInt(number) - 1;
      const variable = variables[variableIndex];
      return variable ? variable.value : "";
    });
    return formatWhatsAppText(replacedText);
  };

  const handleHeaderToggle = () => {
    setIncludeHeader((prevState) => !prevState);
  };
  const handleFooterToggle = () => {
    setIncludeFooter((prevState) => !prevState);
  };
  const handleButtonToggle = () => {
    setIncludeButtons((prevState) => !prevState);
    // if(includeButtons === false){
    //   handleRemoveButton4_quick1();
    //   handleRemoveButton4_quick2();
    //   handleRemoveButton4_quick3();
    //   handleRemoveButton4_quick4();
    // }
  };

  //  useEffect(() => {
  //   if(includeButtons === false){
  //     handleRemoveButton4_quick1();
  //     handleRemoveButton4_quick2();
  //     handleRemoveButton4_quick3();
  //     handleRemoveButton4_quick4();
  //   }
  //  }, [includeButtons])

  // Kewal code
  //geting Whatsapp number register
  const getWhatsappNumber = async (e) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Basic ${BASIC_AUTH}`);
      var raw = JSON.stringify({
        userid: userID,
      });
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${baseUrl}/api/Whatsapp/v1.0/getWhatsappNumbers`,
        requestOptions
      );
      const data = await res.json();
      if (data?.responseCode == "00") {
        setWhatsappNumbers(data?.response);
      } else {
      }
    } catch (error) { }
  };
  useEffect(() => {
    getWhatsappNumber();
  }, []);
  useEffect(() => {
    if (WhatsappNumbers && WhatsappNumbers.length === 1) {
      setMultiplePhoneNumber(false);
      WhatsappNumbers.map((Num, i) => setSingleWhatsApp(Num.phone_no_id));
    } else if (WhatsappNumbers && WhatsappNumbers.length !== 1) {
      setMultiplePhoneNumber(true);
      WhatsappNumbers.map((Num, i) =>
        i === 0 ? setSingleWhatsApp(Num.phone_no_id) : ""
      );
    }
  }, [WhatsappNumbers]);
  useEffect(() => {
    if (!includeButtons) {
      setTimeout(() => {
        handleRemoveButton4_quick1();
        handleRemoveButton4_quick2();
        handleRemoveButton4_quick3();
        handleRemoveButton4_quick4();
      }, 0);
    }
  }, [includeButtons]);

  const componentArrayJSON = JSON.stringify(components, null, 2);

  // Use useMemo to cache the video URL
  const videoPreviewUrl = useMemo(() => {
    return videoFile ? URL.createObjectURL(videoFile) : null;
  }, [videoFile]);

  // Memoized document preview URL
  const documentPreviewUrl = useMemo(() => {
    if (documentFile) {
      return URL.createObjectURL(documentFile);
    }
    return null;
  }, [documentFile]);

  // Close popup when clicking outside

  useEffect(() => {

    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    };

    if (showEmojiPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };


  }, [showEmojiPicker]);
  const handlePhoneChange = (e) => {
    let inputValue = e.target.value;

    // Remove non-numeric characters
    inputValue = inputValue.replace(/\D/g, "");

    // Ensure country code is always present
    if (!inputValue.startsWith(selectedCode)) {
      inputValue = inputValue.replace(/^\d+/, ""); // Remove any existing country code
      inputValue = selectedCode + inputValue;
    }

    // Prevent deletion of the country code
    if (inputValue.length < selectedCode.length) {
      inputValue = selectedCode;
    }

    // Limit to 12 digits (including country code)
    if (inputValue.length > 12) {
      inputValue = inputValue.slice(0, 12);
    }

    setTemplate({
      ...template,
      showButton4_quick3_call: inputValue,
    });
  };
  return (
    <>

      {mediaUploadLoading && <Loader />}


      <NoIndex />
      <div className="d-flex justify-content-center text-center">
        <ToastContainer />
      </div>

      <div className="p-4  " style={{ fontFamily: "Nunito,sans-serif" }}>
        <div className=" bg-white px-4">
          <p className="CreateCampaign px-4">Create New Template</p>

          <div className="w-100 d-flex justify-content-between">
            <div className="form col-7 px-4 py-3">
              {loading ? (
                <div className=" m-5 p-5 d-flex justify-content-center">
                  <div className="loader "></div>
                </div>
              ) : (
                <Form>
                  {/* ######################     Template     ##################*/}
                  <div className=" p-3 border-template">
                    <div className={`col-12`}>
                      <Form.Label className="text-2">
                        Select WhatsApp Number for template Creation
                        <Form.Select
                          className="form-select my-1"
                          value={SingleWhatsApp}
                          onChange={(e) => {
                            setSingleWhatsApp(e.target.value);
                          }}
                          disabled={!MultiplePhoneNumber} // Ensuring this condition works properly
                        >
                          <option value="">Select Number</option>
                          {WhatsappNumbers.map((num, index) => (
                            <option key={index} value={num.phone_no_id}>
                              {num.phone_no_id}-({num.phone_no})
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Label>
                    </div>
                    <FormGroup>
                      <Form.Label className="text2 ">Template Name</Form.Label>
                      <FormControl
                        className=""
                        type="text"
                        name="name"
                        placeholder="Enter Template Name"
                        value={template.name}
                        onChange={handleInputChange}
                      />
                    </FormGroup>

                    <FormGroup className=" py-1">
                      <Form.Label className="text2 ">
                        Template Language
                      </Form.Label>

                      <Form.Select
                        name="templateLanguage"
                        aria-label="Select Language"
                        onChange={handleLanguageChange}
                        value={template.language}
                      >
                        <option value="">Select Language</option>
                        {Languages &&
                          Languages.map((lan, index) => (
                            <option key={index} value={lan.language_code}>
                              {lan.language}
                            </option>
                          ))}
                      </Form.Select>
                    </FormGroup>
                    <FormGroup className=" py-1">
                      <Form.Label className="text2 ">
                        Template Category
                      </Form.Label>
                      <Form.Select
                        className=""
                        name="templateCategory"
                        aria-label=""
                        onChange={handleCategoryChange}
                        value={template.category}
                      >
                        <option value="">Select Category</option>
                        <option value="MARKETING">Marketing</option>
                        <option value="UTILITY">Utility</option>
                      </Form.Select>
                    </FormGroup>
                    {/* <FormGroup className=" py-1">
                      <Form.Label className="text2 ">
                        Template Purpose
                      </Form.Label>
                      <Form.Select
                        className=""
                        name="templatepurpose"
                        aria-label=""
                        onChange={handlePurposeChange}
                        value={template.purpose}
                      >
                        <option value="">Select Purpose</option>
                        <option value="1">Lead Generation</option>
                        <option value="2">Marketing & Awareness</option>
                      </Form.Select>
                    </FormGroup> */}
                  </div>
                  {/* ######################      Header     ##################*/}
                  <div className=" p-3 border-template my-3">
                    <FormGroup className="d-flex align-items-center justify-content-start">
                      <div className="form-check form-switch toggle-container ">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={includeHeader}
                          onChange={handleHeaderToggle}
                          id="headerSwitch"
                        />
                      </div>
                      <label
                        className="form-check-label text-3-2 mb-1 mx-2"
                        htmlFor="headerSwitch"
                      >
                        Header
                      </label>
                      <label
                        className="form-check-label  mb-1 mx-2 d-flex justify-content-center"
                        htmlFor="headerSwitch"
                      >
                        {/* <span className="nav-text font-bold">
                          <span className="text-danger">*</span>Only 1 variable
                          allowed.
                        </span> */}
                      </label>
                    </FormGroup>
                    {includeHeader && (
                      <>
                        <FormGroup>
                          <Form.Label className="text2 mt-3">
                            Header Type
                          </Form.Label>
                          <FormControl
                            className=""
                            as="select"
                            name="headerType"
                            value={template.headerType}
                            onChange={handleHeaderTypeChange}
                          >
                            <option value="">Select Header Type</option>
                            <option value="Text">Text</option>
                            <option value="Image">Image</option>
                            <option value="Video">Video</option>
                            <option value="Document">Document</option>
                          </FormControl>
                        </FormGroup>
                        {template.headerType === "Text" && (
                          <>
                            <FormGroup>
                              <Form.Label className="text2 mt-3">
                                Header
                              </Form.Label>
                              <FormControl
                                className=""
                                as="textarea"
                                name="body"
                                value={template1header.body}
                                onChange={handleInputChange1header}
                              />
                            </FormGroup>
                            {/* <div className=" d-flex justify-content-end">
                              <div
                                className="-filter px-2 border-template m-2 text-white"
                                onClick={addVariableheader}
                                disabled={isAddVariableClicked}
                                style={{
                                  cursor: isAddVariableClicked
                                    ? "not-allowed"
                                    : "pointer",
                                }}
                              >
                                +
                              </div>
                            </div> */}

                            {variablesheader.map((variableheader, index) => (
                              <FormGroup key={index} className="d-flex py-1">
                                <Form.Label className="pe-2">
                                  {variableheader.label}
                                </Form.Label>
                                <FormControl
                                  type="text"
                                  value={variableheader.value}
                                  onChange={(e) =>
                                    handleVariableValueChangeheader(
                                      index,
                                      e.target.value
                                    )
                                  }
                                />
                              </FormGroup>
                            ))}
                          </>
                        )}

                        {template.headerType === "Image" && (
                          <div>
                            <div className="row d-flex justify-content-between p-2 pt-4">
                              <div
                                className="col-12"
                              // style={{ borderRight: "1px dashed #000" }}
                              >
                                <div className="">
                                  <label htmlFor={`image-upload`}>
                                    Upload image in header :{" "}
                                  </label>
                                </div>
                                <input
                                  type="file"
                                  id={`image-upload`}
                                  className="pt-2"
                                  accept="image/*"
                                  onChange={handleImageUpload}
                                />
                              </div>
                            </div>
                            {imageFile.length > 0 && (
                              <div className="d-flex justify-content-center p-2 pt-4">
                                <img
                                  src={URL.createObjectURL(imageFile[0])}
                                  alt="Uploaded"
                                  style={{ maxWidth: "50%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}

                        <div></div>

                        {template.headerType === "Video" && (
                          <div>
                            <div className="row d-flex justify-content-between p-2 pt-4">
                              <div
                                className="col-12"
                              // style={{ borderRight: "1px dashed #000" }}
                              >
                                <div className="">
                                  <label htmlFor={`image-upload`}>
                                    Upload video in header :{" "}
                                  </label>
                                </div>
                                <input
                                  type="file"
                                  id={`video-upload`}
                                  className="pt-2"
                                  accept="video/*"
                                  onChange={handleVideoUpload}
                                />
                              </div>
                            </div>
                            {/* Display Uploaded Video without reloading */}
                            {videoPreviewUrl && (
                              <div className="d-flex justify-content-center p-2 pt-4">
                                <video
                                  controls
                                  style={{ maxWidth: "50%" }}
                                  src={videoPreviewUrl}
                                />
                              </div>
                            )}
                          </div>
                        )}

                        {template.headerType === "Document" && (
                          <div>
                            <div className="row d-flex justify-content-between p-2 pt-4">
                              <div className="col-12">
                                <div>
                                  <label htmlFor="document-upload">
                                    Upload document in header:
                                  </label>
                                </div>
                                <input
                                  type="file"
                                  id="document-upload"
                                  className="pt-2"
                                  accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                                  onChange={handleDocumentUpload}
                                />
                              </div>
                            </div>
                            {documentPreviewUrl && (
                              <div className="d-flex justify-content-center p-2 pt-4">
                                {documentFile.type === "application/pdf" ? (
                                  <iframe
                                    src={documentPreviewUrl}
                                    style={{
                                      width: "100%",
                                      height: "500px",
                                      border: "none",
                                    }}
                                  />
                                ) : (
                                  <p>
                                    Uploaded File:{" "}
                                    <a
                                      href={documentPreviewUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View Document
                                    </a>
                                  </p>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  {/* ###################### BODY #######################*/}
                  <div className=" p-3 border-template my-3">
                    <FormGroup>
                      <div className="d-flex flex-column"></div>
                      <Form.Label className="text2">Body</Form.Label><br />


                      <FormControl
                        as="textarea"
                        id="bodyTextarea"
                        name="body"
                        value={template1.body}
                        onChange={handleInputChange1}
                        className="mt-3"
                      />
                    </FormGroup>
                    <span className="text-muted" style={{ fontSize: "10px" }}>Space more than one line will cause failure of template creation</span>
                    <div className="d-flex justify-content-between">
                      <div className="d-flex gap-4  my-3 round-5">
                        <div>
                          <Button
                            variant="white"
                            size="md"
                            onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                          >
                            😀
                          </Button>
                        </div>
                        <div>
                          <Button
                            variant="dark"
                            size="md"
                            onClick={() => applyFormatting("bold")}
                          >
                            <b>B</b>
                          </Button>
                        </div>
                        <div>
                          <Button
                            variant="dark"
                            size="md"
                            onClick={() => applyFormatting("italic")}
                          >
                            <i>I</i>
                          </Button>
                        </div>
                        <div>
                          <Button
                            variant="dark"
                            size="md"
                            onClick={() => applyFormatting("boldItalic")}
                          >
                            <b>
                              <i>BI</i>
                            </b>
                          </Button>
                        </div>
                      </div>
                      {showEmojiPicker && (
                        <div className="emoji-picker" ref={emojiPickerRef}>
                          <div className="emoji-tabs">
                            <div className="emoji-tabs-wrapper">
                              {Object.keys(emojiCategories).map((category) => (
                                <span
                                  key={category}
                                  className={`emoji-tab ${selectedCategory === category
                                    ? "active"
                                    : ""
                                    }`}
                                  onClick={() => setSelectedCategory(category)}
                                >
                                  {category}
                                </span>
                              ))}
                            </div>
                          </div>
                          <div className="emoji-list">
                            {emojiCategories[selectedCategory].map((emoji) => (
                              <span
                                key={emoji}
                                className="emoji-item"
                                onClick={() => insertEmoji(emoji)}
                              >
                                {emoji}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                      <div
                        className="blue-div px-2  my-3 text-white cursor-pointer blue-button"
                        onClick={addVariable}
                      >
                        Add variable
                      </div>
                    </div>
                    {variables.map((variable, index) => (
                      <FormGroup key={index} className="d-flex py-1">
                        <Form.Label className="pe-2">
                          {variable.label}
                        </Form.Label>
                        <FormControl
                          type="text"
                          value={variable.value}
                          onChange={(e) =>
                            handleVariableValueChange(index, e.target.value)
                          }
                        />
                      </FormGroup>
                    ))}
                  </div>
                  {/* ###################### Footer #######################*/}
                  <div className=" p-3 border-template my-3">
                    <FormGroup className="d-flex align-items-center justify-content-start">
                      <div className="form-check form-switch toggle-container ">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={includeFooter}
                          onChange={handleFooterToggle}
                          id="footerSwitch"
                        />
                      </div>
                      <label
                        className="form-check-label text-3-2 mb-1 mx-2"
                        htmlFor="footerSwitch"
                      >
                        Footer
                      </label>
                    </FormGroup>
                    {includeFooter && (
                      <>
                        <FormGroup>
                          <FormControl
                            type="text"
                            name="footer"
                            className="form-control"
                            value={template.footer} // Default value
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </>
                    )}
                  </div>
                  {/* <div className=" p-3 border-template my-3">
                    <FormGroup className="d-flex align-items-center justify-content-start">
                      <div className="form-check form-switch toggle-container ">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={includeFooter}
                          onChange={handleFooterToggle}
                          id="footerSwitch"
                        />
                      </div>
                      <label
                        className="form-check-label text-3-2 mb-1 mx-2"
                        htmlFor="footerSwitch"
                      >
                        Footer
                      </label>
                    </FormGroup>
                    {includeFooter && (
                      <>
                        <FormGroup>
                          <FormControl
                            className=" mt-3"
                            type="text"
                            name="footer"
                            value={template.footer}
                            onChange={handleInputChange}
                          />
                        </FormGroup>
                      </>
                    )}
                  </div> */}
                  {/* ###################### Button #######################*/}
                  <div className=" p-3 border-template my-3">
                    <FormGroup className="d-flex align-items-center justify-content-start">
                      <div className="form-check form-switch toggle-container ">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={includeButtons}
                          onChange={handleButtonToggle}
                          id="buttonSwitch"
                        />
                      </div>
                      <label className="form-check-label text-3-2 mb-1 mx-2 d-flex justify-content-center">
                        <span>Buttons </span>
                      </label>
                      <label className="form-check-label  mb-1 mx-2 d-flex justify-content-center">
                        <span className="nav-text font-bold">
                          <span className="text-danger">*</span>Maximum 3
                          buttons allowed.
                        </span>
                      </label>
                    </FormGroup>
                    {includeButtons && (
                      <>
                        <FormGroup>
                          <FormControl
                            className=" mt-3"
                            as="select"
                            name="selectButton"
                            onChange={handleButtonTypeChange}
                            ref={buttonTypeSelectRef}
                          >
                            <option value="">Select Button Type</option>
                            <option value="4">Quick Reply Button 1</option>
                            <option value="5">Quick Reply Button 2</option>
                            <option value="6">Visit Website</option>
                            <option value="7">Call phone number </option>
                          </FormControl>
                        </FormGroup>
                        {template.showButton4option_quick1 === "4" && (
                          <>
                            <Form.Label className="text2 mt-3 ">
                              <span>Quick Reply Button 2</span>
                              {template.purpose === "1" && (
                                <>
                                  <span className="footer-text ps-2">
                                    (Example: Interested )
                                  </span>
                                </>
                              )}
                            </Form.Label>
                            <div className="d-flex justify-content-between">
                              <FormGroup className="col-5">
                                <FormControl
                                  className=" "
                                  type="text"
                                  placeholder="Button Name"
                                  name="button"
                                  value={template.showButton4_quick1}
                                  // onChange={handleInputChange}
                                  onChange={(e) => {
                                    setTemplate({
                                      ...template,
                                      showButton4_quick1: e.target.value,
                                    });
                                  }}
                                />
                              </FormGroup>
                              <FormGroup className="col-2">
                                <div
                                  className="-filter p-2 cursor-pointer text-center border-template  text-white "
                                  onClick={(e) => {
                                    handleRemoveButton4_quick1();
                                  }}
                                >
                                  <img src={trash} alt="Logo" />
                                </div>
                              </FormGroup>
                              <FormGroup className="col-4"></FormGroup>
                            </div>
                          </>
                        )}
                        {template.showButton4option_quick2 === "5" && (
                          <>
                            <Form.Label className="text2 mt-3 ">
                              <span>Quick Reply Button 2</span>
                              {template.purpose === "1" && (
                                <>
                                  <span className="footer-text ps-2">
                                    (Example: Not Interested )
                                  </span>
                                </>
                              )}
                            </Form.Label>
                            <div className="d-flex justify-content-between">
                              <FormGroup className="col-5">
                                <FormControl
                                  className=" "
                                  type="text"
                                  placeholder="Button Name"
                                  name="button"
                                  value={template.showButton4_quick2}
                                  // onChange={handleInputChange}
                                  onChange={(e) => {
                                    setTemplate({
                                      ...template,
                                      showButton4_quick2: e.target.value,
                                    });
                                  }}
                                />
                              </FormGroup>

                              <FormGroup className="col-2">
                                <div
                                  className="-filter p-2 cursor-pointer text-center border-template  text-white "
                                  onClick={(e) => {
                                    handleRemoveButton4_quick2();
                                  }}
                                >
                                  <img src={trash} alt="Logo" />
                                </div>
                              </FormGroup>
                              <FormGroup className="col-4"></FormGroup>
                            </div>
                          </>
                        )}

                        {template.showButton4option_quick3 === "6" && (
                          <>
                            <Form.Label className="text2 mt-3 ">
                              Visit website
                            </Form.Label>
                            <div className="d-flex justify-content-between">
                              <FormGroup className="col-5">
                                <FormControl
                                  className=" "
                                  type="text"
                                  placeholder="Button Name"
                                  name="button"
                                  value={template.showButton4_quick3}
                                  // onChange={handleInputChange}
                                  onChange={(e) => {
                                    setTemplate({
                                      ...template,
                                      showButton4_quick3: e.target.value,
                                    });
                                  }}
                                />
                              </FormGroup>
                              <FormGroup className="col-4">
                                <FormControl
                                  className=" "
                                  type="text"
                                  placeholder="URL"
                                  name="buttonUrl"
                                  value={template.showButton4_quick3_url}
                                  onChange={(e) => {
                                    setTemplate({
                                      ...template,
                                      showButton4_quick3_url: e.target.value,
                                    });
                                  }}
                                />
                              </FormGroup>
                              <FormGroup className="col-2">
                                <div
                                  className="-filter p-2 cursor-pointer text-center border-template  text-white "
                                  onClick={(e) => {
                                    handleRemoveButton4_quick3();
                                  }}
                                >
                                  <img src={trash} alt="Logo" />
                                </div>
                              </FormGroup>
                            </div>
                          </>
                        )}
                        {template.showButton4option_quick4 === "7" && (
                          <>
                            <Form.Label className="text2 mt-3 ">
                              Call Phone Number
                            </Form.Label>
                            <div className="d-flex justify-content-between gap-2">
                              <FormGroup className="col-4 m-0 p-0">
                                <FormControl
                                  className=" "
                                  type="text"
                                  placeholder="Button Name"
                                  name="button"
                                  value={template.showButton4_quick4}
                                  // onChange={handleInputChange}
                                  onChange={(e) => {
                                    setTemplate({
                                      ...template,
                                      showButton4_quick4: e.target.value,
                                    });
                                  }}
                                />
                              </FormGroup>
                              <FormGroup className="col-2 m-0 p-0">
                                {/* Country Code Dropdown */}
                                <Form.Select
                                  className="me-2"
                                  value={selectedCode}
                                  onChange={(e) =>
                                    setSelectedCode(e.target.value)
                                  }
                                >
                                  {countryCodes.map((country) => (
                                    <option
                                      key={country.code}
                                      value={country.code}
                                    >
                                      {country.label}
                                    </option>
                                  ))}
                                </Form.Select>


                              </FormGroup>

                              <FormGroup className="col-4 m-0 p-0">
                                {/* Phone Number Input */}
                                <FormControl
                                  type="text"
                                  placeholder="Enter phone number"
                                  name="buttonUrl"
                                  value={template.showButton4_quick3_call}
                                  onChange={handlePhoneChange}
                                />
                              </FormGroup>
                              <FormGroup className="col-1 m-0 p-0">
                                <div
                                  className="-filter p-2 cursor-pointer text-center border-template  text-white "
                                  onClick={(e) => {
                                    handleRemoveButton4_quick4();
                                  }}
                                >
                                  <img src={trash} alt="Logo" />
                                </div>
                              </FormGroup>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                  <div className=" d-flex justify-content-start">
                    <div
                      className="blue-div px-5 py-2 my-3 text-3-2 cursor-pointer  blue-button"
                      onClick={chooseAPI}
                    >
                      Submit
                    </div>
                  </div>
                </Form>
              )}
            </div>
            <div className="col-5  p-4 ">
              <div className="">
                <div className="pt-4  align-items-center d-flex justify-content-center">
                  <div className="">
                    <div className="pb-2 text2 text-center">
                      Sample Message Preview
                    </div>
                    <div className="col-12 col-md-3 mt-4 mt-md-0">
                      <div
                        className="mobile-card"
                        style={{ position: "absolute" }}
                      >
                        <div className="mobile-btn1"></div>
                        <div className="mobile-btn2"></div>
                        <div className="mobile-btn3"></div>
                        <div className="mobile-btn4"></div>
                        <div className="mobile-card-int">
                          {/* Scrollable message container */}
                          <div className="scrollable-content">
                            <div className="bubble-container">
                              <div className="chat-border p-2">
                                {imageFile.length > 0 ? (
                                  <img
                                    src={URL.createObjectURL(imageFile[0])}
                                    alt="Uploaded"
                                    style={{ maxWidth: "100%" }}
                                  />
                                ) : videoPreviewUrl ? (
                                  <div className="d-flex justify-content-center p-2 pt-4">
                                    <video
                                      controls
                                      style={{ maxWidth: "100%" }}
                                      src={videoPreviewUrl}
                                    />
                                  </div>
                                ) : (

                                  <div className="header-text">
                                    {replaceVariablesheader(
                                      template1header.body
                                    ) || "Header"}
                                  </div>
                                )}

                                <div className="body-text py-1">

                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        replaceVariables(template1.body)
                                          .length > 605
                                          ? replaceVariables(
                                            template1.body
                                          ).slice(0, 605) + "..."
                                          : replaceVariables(template1.body),
                                    }}
                                  />
                                </div>

                                <div className="footer-text text-secondary">
                                  {template.footer}
                                </div>

                                <div className="footer-text text-end pb-2">
                                  05:27 PM
                                </div>

                              </div>

                              {/* Buttons */}

                              <div>
                                {template.showButton4_quick1 && (
                                  <div className="showButton my-2">
                                    {template.showButton4_quick1}
                                  </div>
                                )}
                                {template.showButton4_quick2 && (
                                  <div className="showButton my-2">
                                    {template.showButton4_quick2}
                                  </div>
                                )}
                                {template.showButton4_quick3 && (
                                  <div className="showButton my-2">
                                    {template.showButton4_quick3}
                                  </div>
                                )}
                                {template.showButton4_quick4 && (
                                  <div className="showButton my-2">
                                    {template.showButton4_quick4}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mobile-top">
                          <div className="mobile-camera">
                            <div className="mobile-int"></div>
                          </div>
                          <div className="mobile-speaker"></div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateTemplate;
